import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Typography, Tabs } from 'antd';
import './UserProfileModal.css';
import { CloseOutlined } from '@ant-design/icons';
import { getIframesToken, IS_IFRAMES, PATH_CUSTOMER_ID } from '../../constants';

const { Text } = Typography;

const UserProfileModal = ({ 
    isOpen, 
    onClose, 
    profile, 
    onCheckOut, 
    activeTab, 
    setActiveTab, 
    companyPayMode, 
    currentBillingStatus, 
    portalSessionUrl,
    downgradedTime,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [billingInfo, setBillingInfo] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    // Initialize form with profile data
    useEffect(() => {
        if (profile && isOpen) {
            console.log('profile', profile);
            form.setFieldsValue({
                firstName: profile.FirstName || '',
                lastName: profile.LastName || '',
                nmlsId: profile.NMLSID || '',
                organizationName: profile.OrganizationName || '',
                brokerageNmlsId: profile.BrokerageNMLSID || ''
            });
        }
    }, [profile, isOpen, form]);

    useEffect(() => {
        if (profile?.AccountTier === 'paid' && companyPayMode === 'self_pay') {
            fetchBillingInfo();
        }
    }, [profile, companyPayMode]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Check on mount

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchBillingInfo = async () => {
        try {
            const response = await fetch('/api/v1/los/stripe/getBillingInfo', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem(getIframesToken())}`,
                },
                body: JSON.stringify({
                    customerId: PATH_CUSTOMER_ID,
                    loanOfficerID: profile.LoID,
                }),
            });
            if (response.ok) {
                const data = await response.json();
                console.log('billing info', data);
                const nextBillingDate = new Date(data.nextBillingDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
                setBillingInfo({
                    subscriptionId: data.subscriptionId,
                    status: data.status,
                    nextBillingDate: nextBillingDate,
                });
            } else {
                message.error('Failed to fetch billing info');
            }
        } catch (error) {
            console.error('Error fetching billing info:', error);
        }
    }

    const handleSave = async (values) => {
        setLoading(true);
        try {
            // TODO: Implement API call to save profile data
            console.log('Saving profile data:', values);

            // Simulate API call
            // guidelinegpt 非iframe 用户也在使用这个组件，但是对应的update的接口不一样
            const response = await fetch(IS_IFRAMES ? '/los/iframe/updateprofile' : '/los/updateprofile', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${IS_IFRAMES ? localStorage.getItem(getIframesToken()) : sessionStorage.getItem('ZeitroA')}`,
                },
                body: JSON.stringify(IS_IFRAMES ? {
                    firstName: values.firstName,
                    lastName: values.lastName,
                    nmlsId: values.nmlsId,
                    branchName: values.organizationName,
                    brokerageNmlsId: values.organizationName,
                } : {
                    firstname: values.firstName,
                    lastname: values.lastName,
                    nmls: values.nmlsId,
                    email: profile.Email,
                    phone: profile.Phone,
                    image: profile.Image,
                    introduction: profile.Introduction,
                    licenseid: profile.LicenseID
                }),
            })

            if (response.ok) {
                message.success('Profile updated successfully');
                onClose();
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                message.error('Failed to update profile');
            }
        } catch (error) {
            console.error('Error saving profile:', error);
            message.error('Failed to update profile');
        } finally {
            setLoading(false);
        }
    }

    const handleCancel = () => {
        form.resetFields();
        onClose();
    };

    const handleManageBillingClick = () => {
        window.location.href = portalSessionUrl;
    }

    const renderPlanDescription = () => {
        if (profile?.AccountTier === 'free' && currentBillingStatus === 'inactive') {
            return(
                <div className="section-description">Your account activated on {profile?.CreatedAt}.</div> 
            )
        }
        if (profile?.AccountTier === 'free' && (currentBillingStatus === 'past_due' || currentBillingStatus === 'canceled')) {
            return(
                <div className="section-description">Your plan was downgraded on {downgradedTime}.</div>
            )
        }
        if (profile?.AccountTier === 'paid' && currentBillingStatus === 'active') {
            return(
                <div className="section-description">Your plan auto-renews on {billingInfo?.nextBillingDate}.</div>
            )
        }
    }

    const renderBillingContent = () => {
        return (
            <div className="user-profile-modal-content">
                <div className="modal-main-content">
                    <div className="content-header">
                        <div className="content-title">Billing</div>
                    </div>

                    <div className="billing-subscription-container">
                        <div className="content-subtitle">Manage subscription</div>
                        <div className="billing-subscription-section">
                            <div className="section-content">
                                <div className="section-title">{profile?.AccountTier === 'free' ? 'Starter' : 'Business'} Plan</div>
                                {/* {
                                        profile?.AccountTier === 'free' ? 
                                        <div className="section-description">Your account activated on {profile?.CreatedAt}.</div> 
                                        :
                                        <div className="section-description">Your plan auto-renews on {billingInfo?.nextBillingDate}.</div>
                                } */}
                                {renderPlanDescription()}
                            </div>
                            <div className="section-button">
                                {
                                    profile?.AccountTier === 'free' ? (
                                        currentBillingStatus === 'past_due' ? (
                                            <Button type="primary" onClick={onCheckOut}>Upgrade</Button>
                                        ) : (
                                            <Button type="primary" className='user-profile-modal-upgrade-btn' onClick={onCheckOut}>Upgrade</Button>
                                        )
                                    ):(
                                        <Button type="primary" className='user-profile-modal-upgrade-btn' onClick={handleManageBillingClick}>Manage</Button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderAccountContent = () => {
        return (
            <div className="user-profile-modal-content">
                {/* <div className="userprofile-modal-close-button" onClick={handleCancel}>
                    <CloseOutlined />
                </div> */}
                {/* Left Sidebar Navigation */}
                {/* <div className="modal-sidebar">
                    <div className="sidebar-nav-item active">
                        <div className="nav-item-icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <span className="nav-item-text">Account</span>
                    </div>
                </div> */}

                {/* Right Content Area */}
                <div className="modal-main-content">
                    <div className="content-header">
                        <div className="content-title">Account</div>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSave}
                        className="profile-form"
                    >
                        <div className="form-row form-row-split">
                            <Form.Item
                                label="First name"
                                name="firstName"
                                rules={[{ required: true, message: 'Please enter your first name' }]}
                                className="form-item form-item-half"
                            >
                                <Input placeholder="Enter your first name" />
                            </Form.Item>
                            <Form.Item
                                label="Last name"
                                name="lastName"
                                rules={[{ required: true, message: 'Please enter your last name' }]}
                                className="form-item form-item-half"
                            >
                                <Input placeholder="Enter your last name" />
                            </Form.Item>
                        </div>

                        <div className="form-row">
                            <Form.Item
                                label="NMLS ID"
                                name="nmlsId"
                                rules={[{ required: true, message: 'Please enter your NMLS ID' }]}
                                className="form-item"
                            >
                                <Input placeholder="Enter your NMLS ID" />
                            </Form.Item>
                        </div>

                        {IS_IFRAMES ? <>
                            {
                                PATH_CUSTOMER_ID !== 'greenbox' && <div className="form-row">
                                <Form.Item
                                        label="Organization Name"
                                        name="organizationName"
                                        rules={[{ required: true, message: 'Please enter your organization name' }]}
                                        className="form-item"
                                    >
                                        <Input placeholder="Enter your organization name" />
                                    </Form.Item>
                                </div>
                            }

                            <div className="form-row">
                                <Form.Item
                                    label="Brokerage NMLS ID"
                                    name="brokerageNmlsId"
                                    className="form-item"
                                >
                                    <Input placeholder="Enter your company's NMLS ID" />
                                </Form.Item>
                            </div>
                        </> : null}

                        <div className="form-actions">
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                loading={loading}
                                className="save-button"
                            >
                                Save Change
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

    const profileItems = [
        companyPayMode === 'self_pay' && {
            key: 'billing',
            label: (
                <span style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#222222' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.333 3.33398H2.66634C1.92996 3.33398 1.33301 3.93094 1.33301 4.66732V11.334C1.33301 12.0704 1.92996 12.6673 2.66634 12.6673H13.333C14.0694 12.6673 14.6663 12.0704 14.6663 11.334V4.66732C14.6663 3.93094 14.0694 3.33398 13.333 3.33398Z" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.33301 6.66602H14.6663" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Billing
                </span>
            ),
            children: renderBillingContent(),
        },
        {
            key: 'account',
            label: (
                <span style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#222222' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.6663 14V12.6667C12.6663 11.9594 12.3854 11.2811 11.8853 10.781C11.3852 10.281 10.7069 10 9.99967 10H5.99967C5.29243 10 4.61415 10.281 4.11406 10.781C3.61396 11.2811 3.33301 11.9594 3.33301 12.6667V14" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.99967 7.33333C9.47243 7.33333 10.6663 6.13943 10.6663 4.66667C10.6663 3.19391 9.47243 2 7.99967 2C6.52692 2 5.33301 3.19391 5.33301 4.66667C5.33301 6.13943 6.52692 7.33333 7.99967 7.33333Z" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Account
                </span>
            ),
            children: renderAccountContent(),
        },

    ];

    return (
        <Modal
            open={isOpen}
            onCancel={handleCancel}
            footer={null}
            className="user-profile-modal"
            closable={false}
        >
            <div className="user-profile-modal-close-button" onClick={handleCancel}>
                <CloseOutlined />
            </div>
            <Tabs
                defaultActiveKey="billing"
                activeKey={activeTab}
                onChange={setActiveTab}
                tabPosition={isMobile ? "top" : "left"}
                items={profileItems}
            />
        </Modal>
    );
};

export default UserProfileModal;